import React from 'react';
import ReactDOM from 'react-dom/client';
// RGPD-4.6 : Plus Jakarta Sans en self-host (cf. tailwind.config.js fontFamily.sans).
// Memes weights que l'ancien @import Google Fonts (300, 400, 500, 600, 700, 800).
import '@fontsource/plus-jakarta-sans/300.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import { ToastProvider } from './context/ToastContext';
import { ConfirmProvider } from './context/ConfirmContext';
import { ApiInterceptorBridge } from './components/ApiInterceptorBridge';
import ConflictToastBridge from './components/ConflictToastBridge';
import { installRateLimitInterceptor } from './utils/apiInterceptor';
import ErrorBoundary from './components/ErrorBoundary';
import { installGlobalErrorHandlers, installAssetErrorNet } from './utils/clientTelemetry';

// LOT URGENT P0 FE-1 — installe l'intercepteur axios 429 une fois au boot.
installRateLimitInterceptor();

// Anti-page-blanche (audit M1) — handlers globaux JS + filet asset one-shot.
installGlobalErrorHandlers();
installAssetErrorNet();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* ErrorBoundary racine HORS providers : fallback autonome si un provider crashe. */}
    <ErrorBoundary>
      <BrowserRouter>
        <ThemeProvider>
          <LanguageProvider>
            <ToastProvider>
              <ConfirmProvider>
                <AuthProvider>
                  <App />
                  <ApiInterceptorBridge />
                  <ConflictToastBridge />
                </AuthProvider>
              </ConfirmProvider>
            </ToastProvider>
          </LanguageProvider>
        </ThemeProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
